import { FC, useRef } from "react";
import { Button, Input, InputProps } from "antd";

const CopyTextInput: FC<{ text: string; inputProps?: InputProps }> = ({
  text,
  inputProps,
}) => {
  const inputRef = useRef<any>(null);
  const handleCopy = () => {
    inputRef.current.select();
    inputRef.current.setSelectionRange(0, 99999);
    document.execCommand("copy");
  };

  return (
    <Input
      ref={inputRef}
      addonAfter={
        <Button
          onClick={handleCopy}
          size="small"
          type="text"
          className="secondary"
        >
          Copy Link
        </Button>
      }
      value={text}
      {...inputProps}
    />
  );
};

export default CopyTextInput;
